<template>
    <div>
        <!-- VIEW -->
        <v-container>
            <v-row class="ma-0">
                <v-col>
                <p class="headline text-center">Monitoring Ijin Usaha</p>
                </v-col>
            </v-row>
            <v-row class="ma-0">
                <v-col>
                    <v-btn-toggle
                        v-model="filter"
                        borderless
                        @change="getData()"
                    >
                        <v-btn value="all">
                            <span class="hidden-sm-and-down">Semua</span>
                        </v-btn>
                        <v-btn value="tidakBerlaku">
                            <span class="hidden-sm-and-down">TiDAK Berlaku</span>
                        </v-btn>
                        <v-btn value="berlaku">
                            <span class="hidden-sm-and-down">Berlaku</span>
                        </v-btn>
                    </v-btn-toggle>
                </v-col>
            </v-row>
            <v-row class="ma-0">
                <v-col cols="12">
                    <v-data-table
                            class="elevation-1"
                            :headers="table.headers"
                            :items="table.items"
                            :items-per-page="10"
                            :single-select="true"
                            :search="search"
                            item-key="id"
                            no-data-text="Belum ada data !"
                            height="400"
                            fixed-header>
                            <template v-slot:item.berlaku="{item}">
                                {{ getDateFormattedDatefns(item.berlaku, "dd MMM yyyy") }}                    
                            </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    const axios = require("axios").default;
    const apiUrl = process.env.VUE_APP_ROOT_API;
    import { format, parseISO } from 'date-fns';

    export default {
        data() {
            return {
                filter: "all",
                search: "",
                table:
                {
                    headers: 
                    [
                        { text: "Nama Perusahaan", value:"nama"},
                        { text: "Bentuk Perusahaan", value:"bentuk"},
                        { text: "Jenis Dokumen", value:"jenis"},
                        { text: "Nomor", value:"nomor"},
                        { text: "Berlaku Sampai Dengan", value:"berlaku"},
                        { text: "Hari", value:"hari"}
                    ],
                    items: []
                },
            }
        },
        created() {
            this.getData();
        },
        methods:{
            getData() {
                console.log('filter', this.filter)
                axios.get(`${apiUrl}/monitor2/ijin-usaha/${this.filter}`)
                .then((response) => {
                    this.table.items = response.data.data;
                    
                })
                .catch((error) => {
                    console.error(error);
                });
            },
            getDateFormattedDatefns: function(date, form = "dd MMM yyyy") {
                return date ? format(parseISO(date), form) : ''
            },
        }
    }

</script>

            
<style scoped>

    .container{
        max-width: 100vw;
        padding:0px;
    }

</style>